import { useSyncExternalStore } from "react";

// =============================================================================

const subscribe = () => () => {};

/**
 * False during SSR and hydration, true afterwards: for UI that depends on
 * browser-only state (the theme stored by next-themes…).
 */
export function useHydrated(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => true,
    () => false
  );
}

// =============================================================================
